import { Stack } from "@mui/material";
import { FC } from "react";
import SalifyTypography from "../../typography/default";
import { HeaderBlock as HeaderBlockType } from "../types";

interface HeaderBlockProps {
  header: HeaderBlockType;
  theme: string;
}

const HeaderBlock: FC<HeaderBlockProps> = ({ header, theme }) => {
  const getThemeStyles = () => {
    switch (theme) {
      case "haianh":
        return {
          subtitle: {
            fontSize: 14,
            fontWeight: 600,
            color: "#FFC107",
            textTransform: "uppercase" as const,
            letterSpacing: "1px",
          },
          title: {
            fontSize: 20,
            fontWeight: 700,
            color: "#1a1a1a",
            lineHeight: 1.3,
          },
        };
      case "nova-press":
        return {
          subtitle: {
            fontSize: 14,
            fontWeight: 600,
            color: "#01a750",
            textTransform: "uppercase" as const,
            letterSpacing: "1px",
          },
          title: {
            fontSize: { xs: 22, md: 28 },
            fontWeight: 700,
            color: "#1a1a1a",
            lineHeight: 1.3,
          },
        };
      default:
        return {
          subtitle: {
            fontSize: 14,
            fontWeight: 600,
            color: "#666",
            textTransform: "uppercase" as const,
            letterSpacing: "0.5px",
          },
          title: {
            fontSize: 18,
            fontWeight: 700,
            color: "#1a1a1a",
            lineHeight: 1.4,
          },
        };
    }
  };

  const themeStyles = getThemeStyles();

  return (
    <Stack spacing={1} alignItems="flex-start" {...header.stackProps}>
      {header.subtitle?.text && (
        <SalifyTypography
          text={header.subtitle.text}
          cssProps={{
            ...themeStyles.subtitle,
            ...header.subtitle.cssProps,
          }}
        />
      )}
      {header.title?.text && (
        <SalifyTypography
          text={header.title.text}
          cssProps={{
            ...themeStyles.title,
            ...header.title.cssProps,
          }}
        />
      )}
    </Stack>
  );
};

export default HeaderBlock;
